<template>
    <flat-pickr
v-model="internalValue" :class="['form-control', { 'is-invalid': hasError }]" :config="config"
        v-bind="$attrs" @click.stop @mousedown.stop />
    <div v-if="hasError" class="invalid-feedback">
        {{ errors[errorFieldName][0] }}
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import 'flatpickr/dist/plugins/monthSelect/style.css';

const props = defineProps({
    modelValue: {
        type: [String, Number, Date, Array, null],
        default: null
    },
    errors: {
        type: Object,
        default: () => ({})
    },
    errorFieldName: {
        type: String,
        required: true
    },
    mode: {
        type: String,
        default: 'date', // 'date' o 'month'
        validator: (value) => ['date', 'month'].includes(value)
    }
});

const emit = defineEmits(['update:modelValue']);
const internalValue = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
    internalValue.value = newValue;
});

watch(internalValue, (newValue) => {
    emit('update:modelValue', newValue);
});

const hasError = computed(() => {
    return props.errors && props.errors[props.errorFieldName];
});

const isDropdownOpen = ref(false);

const config = computed(() => {
    const baseConfig = {
        wrap: true,
        altInput: true,
        locale: Spanish,
        allowInput: false
    };

    if (props.mode === 'month') {
        return {
            ...baseConfig,
            plugins: [
                monthSelectPlugin({
                    shorthand: false,
                    dateFormat: 'Y-m',
                    altFormat: 'F Y',
                    theme: 'light'
                })
            ]
        };
    }

    return {
        ...baseConfig,
        altFormat: 'd/m/y',
        dateFormat: 'Y-m-d',
        onClose: () => {
            setTimeout(() => {
                isDropdownOpen.value = true;
            }, 50);
        }
    };
});
</script>

<style scoped>
.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
    color: #dc3545;
}
</style>